import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=c6a9415e&scoped=true&"
import script from "./ButtonDelete.vue?vue&type=script&lang=js&"
export * from "./ButtonDelete.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDelete.vue?vue&type=style&index=0&id=c6a9415e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a9415e",
  null
  
)

export default component.exports